/* eslint-disable import/no-extraneous-dependencies */ function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { from } from "rxjs";
import { map } from "rxjs/operators";
import { CoralResponse, CoralInterceptor } from "@amzn/ihm-js-coral-client";
import getCSRFToken from "@amzn/carrierlogistics-commons/dist/utils/csrf";
import { CSRF_TOKEN_ID } from "@amzn/carrierlogistics-commons/dist/constants/index";
/*
 * This class is used during client construction, and helps to
 * intercept the headers during request handling for the passport external App.
 */ var RequestOptionsInterceptorForCarrierLogistics = /*#__PURE__*/ function(CoralInterceptor) {
    "use strict";
    _inherits(RequestOptionsInterceptorForCarrierLogistics, CoralInterceptor);
    var _super = _create_super(RequestOptionsInterceptorForCarrierLogistics);
    function RequestOptionsInterceptorForCarrierLogistics() {
        var bindings = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, RequestOptionsInterceptorForCarrierLogistics);
        var _this;
        _this = _super.call(this);
        _this.bindings = bindings;
        return _this;
    }
    _create_class(RequestOptionsInterceptorForCarrierLogistics, [
        {
            /**
   * @param {CoralRequest} request
   * @param {CoralHandler} next
   * @returns
   */ // eslint-disable-next-line class-methods-use-this
            key: "intercept",
            value: function intercept(request, next) {
                // Adding required header
                var headers = [
                    [
                        "Accept",
                        "application/json"
                    ],
                    [
                        "Content-Type",
                        "application/json"
                    ],
                    [
                        CSRF_TOKEN_ID,
                        getCSRFToken()
                    ]
                ];
                var modifiedRequest = request.clone({
                    headers: headers,
                    credentials: "same-origin"
                });
                return from(next.handle(modifiedRequest)).pipe(map(function(response) {
                    var responseHeaders = response.headers;
                    return new CoralResponse(response);
                }));
            }
        }
    ]);
    return RequestOptionsInterceptorForCarrierLogistics;
}(CoralInterceptor);
export default RequestOptionsInterceptorForCarrierLogistics;

//# sourceMappingURL=CarrierLogisticsRequestOptionsInterceptor.js.map